/**
 * 未读红点共享 context（T4 统一通知中心）。
 *
 * 职责边界（保持依赖方向 app → features → shared）：
 *  - shared 层只定义「channel」：context 类型 + 默认值 + 消费 hook；
 *  - features/notifications 提供 Provider 实现（拉取 unread-count）；
 *  - routes/__layout.tsx 负责把 Provider 挂到 MobileShell 外层；
 *  - shared/ui/MobileTabBar 只消费 hook，在「我」tab 上渲染红点。
 *
 * 默认实现是 no-op（count=0），任何在 Provider 外使用 useUnreadBadge 的
 * 组件（孤立测试 / storybook）都不会崩。
 */

import { createContext, useContext } from 'react';

export interface UnreadBadgeState {
  /** 当前未读通知数；0 = 无红点 */
  count: number;
  approvalCount: number;
  /** 主动重新拉取（通知列表加载、单条已读、焦点恢复后调用） */
  refresh: () => Promise<void>;
}

const noopRefresh = async (): Promise<void> => {};

export const UnreadBadgeContext = createContext<UnreadBadgeState>({
  count: 0,
  approvalCount: 0,
  refresh: noopRefresh,
});

/** 读取全局未读徽标状态；Provider 外调用返回默认空态。 */
export function useUnreadBadge(): UnreadBadgeState {
  return useContext(UnreadBadgeContext);
}
